import React from 'react';
import PropTypes from 'prop-types';
import { bookingShape, userShape } from 'constants/propTypes';
import { useDefaultedCurrencyFromURL } from 'utils/hooks/currency';
import { Page } from 'components/shared/Layout';

import ExtrasHotel from './ExtrasHotel';
import ExtrasInsurance from './ExtrasInsurance';
import ExtrasTrain from './ExtrasTrain';
import ExtrasSubscriptions from './ExtrasSubscriptions';
import HotelStatusConflictWarning from '../HotelStatusConflictWarning';
import { getIsPackageBookingOnly } from 'components/ui/Payments/Payments.utils';

const Extras = ({ booking, user, refetch }) => {
  const { hotels, insurances, travelPassProducts, additionalDetails = [], payments = [] } = booking;

  const [currency] = useDefaultedCurrencyFromURL({
    availableCurrencies: user.paymentCurrencies,
    defaultCurrency: booking.currency,
    isMultiCurrency: booking.isMultiCurrency
  });

  const productType = getIsPackageBookingOnly(additionalDetails);

  const isHotelOnly = additionalDetails.some(({ key, value }) => key === 'product_type' && value === 'hotels');

  return (
    <>
      <HotelStatusConflictWarning booking={booking} refetch={refetch} />
      <Page>
        <ExtrasTrain user={user} booking={booking} currency={currency} refetch={refetch} />
        <ExtrasHotel
          hotels={hotels}
          additionalDetails={additionalDetails}
          bookingReference={booking.reference}
          bookingStatus={booking.displayStatus}
          currency={currency}
          isPackage={!!productType}
          isHotelOnly={isHotelOnly}
          payments={payments}
        />
        <ExtrasInsurance insurances={insurances} bookingReference={booking.reference} />
        <ExtrasSubscriptions travelPassProducts={travelPassProducts} />
      </Page>
    </>
  );
};
export default Extras;

Extras.propTypes = {
  booking: bookingShape,
  user: userShape,
  refetch: PropTypes.func.isRequired
};
